import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M10.424 14.253a.5.5 0 0 0 .707-.707 2.5 2.5 0 0 1 0-3.536l3.182-3.182a2 2 0 1 1 2.829 2.829l-2.475 2.475a.5.5 0 1 0 .707.707l2.475-2.475a3 3 0 1 0-4.243-4.243l-3.182 3.182a3.5 3.5 0 0 0 0 4.95"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.546 10.718a.5.5 0 0 0-.708.707 2.5 2.5 0 0 1 0 3.535l-3.182 3.182a2 2 0 0 1-2.828-2.828l2.475-2.475a.5.5 0 1 0-.707-.707L5.12 14.607a3 3 0 0 0 4.243 4.242l3.181-3.182a3.5 3.5 0 0 0 0-4.95"
  })]
}), 'CopyLink');
//# sourceMappingURL=index.js.map